import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SairComponent } from './sair.component';

const routes: Routes = [
  {
    path: '',
    component: SairComponent,
    title: 'Sair',
    children: [{ path: ':mode', redirectTo: '', pathMatch: 'full' }]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SairRoutingModule { }
